// utils/safeRandomUUID.ts
export function safeRandomUUID(): string {
  // Browser / modern Node with Web Crypto
  if (
    typeof globalThis !== 'undefined' &&
    (globalThis as any).crypto &&
    typeof (globalThis as any).crypto.randomUUID === 'function'
  ) {
    return (globalThis as any).crypto.randomUUID()
  }

  // Fallback: not cryptographically perfect, but fine for S3 keys / client IDs
  const rnd = Math.random().toString(16).slice(2)
  const time = Date.now().toString(16)
  return `${time}-${rnd}`
}